import {hoistCmp, uses} from '@xh/hoist/core';
import {SplitProcessorModel} from './SplitProcessorModel';
import {dialog} from '@xh/hoist/kit/blueprint';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {splitIcon} from '../../../../../core/Icons';

export const splitProcessor = hoistCmp.factory({
    className: 'security-import-dialog',
    model: uses(SplitProcessorModel),
    render({className, model}) {
        return dialog({
            style: {width: 600, height: 400},
            isOpen: model.isOpen,
            title: 'Process Splits',
            icon: splitIcon(),
            onClose: () => model.close(),
            canEscapeKeyClose: false,
            canOutsideClickClose: false,
            item: panel({
                item: grid(),
                mask: model.apiTask
            })
        });
    }
});
